import { render, staticRenderFns } from "./live-video.vue?vue&type=template&id=0205195a&scoped=true&"
import script from "./live-video.vue?vue&type=script&lang=js&"
export * from "./live-video.vue?vue&type=script&lang=js&"
import style0 from "./live-video.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./live-video.vue?vue&type=style&index=1&id=0205195a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0205195a",
  null
  
)

export default component.exports